
import dust from "dustjs-linkedin";


(function(){dust.register("debug/opening",body_0);function body_0(chk,ctx){return chk.write("<div class=\"debug-view-opening-widget\"><header><div class=\"close\"></div></header><main><button class=\"open\">Open debug view</button></main></div>");}return body_0;})();

export default 0;
